function safeClasses(classes) {
	if (!Array.isArray(classes)) return [];
	return classes
		.map((value) => String(value || "").trim())
		.filter((value) => /^[a-zA-Z0-9_-]+$/.test(value));
}

export function recommendationProductAction(product, wooAction = null) {
	const productUrl = product.url || "#";
	if (wooAction?.matched && wooAction.text && wooAction.href) {
		return {
			text: String(wooAction.text),
			href: String(wooAction.href),
			classes: safeClasses(wooAction.classes),
			ajax: Boolean(wooAction.ajax),
			productId: String(wooAction.product_id || product.productId || ""),
			productSku: String(wooAction.product_sku || product.sku || ""),
			productName: String(wooAction.product_name || product.title || ""),
			productPrice: String(wooAction.price ?? product.priceAmount ?? ""),
			productCategory: String(wooAction.category || product.categories?.join(", ") || ""),
		};
	}

	return {
		text: "View product",
		href: productUrl,
		classes: ["product_type_unknown"],
		ajax: false,
		productId: String(product.productId || ""),
		productSku: String(product.sku || ""),
		productName: String(product.title || ""),
		productPrice: String(product.priceAmount ?? ""),
		productCategory: String(product.categories?.join(", ") || ""),
	};
}
